export function promiseHandler(promise) {
  try {
    return promise.then((data) => [data, null]).catch((error) => [null, error]);
  } catch (error) {
    return [null, error];
  }
}
